/**
 * MSW handlers for topology REST auth (axios → /auth-login, /auth-me).
 * Only registered when VITE_TEST_MODE is true (see browser.ts).
 */
import { http, HttpResponse } from 'msw';

import { E2E_REST_AUTH } from './constants';

function mockUser(email: string) {
  const now = new Date().toISOString();
  return {
    id: 'default_admin',
    name: email,
    email,
    created_at: now,
    updated_at: now,
  };
}

export const testModeAuthHandlers = [
  http.post('*/auth-login', async ({ request }) => {
    const body = (await request.json()) as {
      email?: string;
      password?: string;
    };
    const email = String(body?.email ?? '').trim();
    const password = String(body?.password ?? '');
    if (email === E2E_REST_AUTH.email && password === E2E_REST_AUTH.password) {
      return HttpResponse.json(
        {
          data: {
            message: 'Login successful',
            user: mockUser(email),
            session_token: 'mock-session-token-for-testing',
            status: 200,
          },
          status: 200,
          message: 'Login successful',
        },
        { status: 200 },
      );
    }
    return HttpResponse.json(
      {
        data: null,
        status: 401,
        message: 'Invalid email or password',
      },
      { status: 401 },
    );
  }),

  http.get('*/auth-me', () =>
    HttpResponse.json(
      {
        data: {
          message: 'User retrieved successfully',
          user: mockUser(E2E_REST_AUTH.email),
          status: 200,
        },
        status: 200,
        message: 'User retrieved successfully',
      },
      { status: 200 },
    ),
  ),
];
